import {Component, EventEmitter, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'table-columns-configuration-dialog',
  templateUrl: './table-columns-configuration-dialog.component.html',
  styleUrls: ['./table-columns-configuration-dialog.component.scss']
})
export class TableColumnsConfigurationDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<TableColumnsConfigurationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  selectAll = true;
  onApply = new EventEmitter();
  onCancel = new EventEmitter();

  ngOnInit(): void {
    this.updateAllComplete();
  }

  ok(): void {
    this.onApply.emit();
  }

  updateAllComplete(): void {
    this.selectAll = this.data.columns != null && this.data.columns.every(t => t.selected);
  }

  someComplete(): boolean {
    if (this.data.columns == null) {
      return false;
    }
    return this.data.columns.filter(t => t.selected).length > 0 && !this.selectAll;
  }

  setAll(selected: boolean): void {
    this.selectAll = selected;
    if (this.data.columns == null) {
      return;
    }
    this.data.columns.forEach(t => t.selected = selected);
  }

}
